import { combineReducers } from 'redux'
import counter from './counter/CounterReducer'
import MediaQueryReducer from 'redux-modules/media-query/MediaQueryReducer'
import MediaQueryConstants from 'redux-modules/media-query/MediaQueryConstants'
import EnquiryReducer from 'redux-modules/enquiry/EnquiryReducer'
import EnquiryConstants from 'redux-modules/enquiry/EnquiryConstants'

export default combineReducers({
    [MediaQueryConstants.reducerName]: MediaQueryReducer,
    [EnquiryConstants.reducerName]: EnquiryReducer,
  counter
})



// WEBPACK FOOTER //
// ./src/redux-modules/index.js